var _effectorFileName = "/builds/gmini/front-ui-kit/src/ToggleSwitch/ToggleSwitch.tsx";
import { Knob, Switch } from './ToggleSwitch.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToggleSwitch = ({
  onToggle,
  active,
  size = 'small',
  disabled,
  color = '#353B60',
  hoverColor = '#353B60',
  selectedColor = '#353B60'
}) => /*#__PURE__*/_jsx(Switch, {
  disabled: disabled,
  size: size,
  onClick: () => !disabled && (onToggle === null || onToggle === void 0 ? void 0 : onToggle(!active)),
  active: active,
  color: color,
  hoverColor: hoverColor,
  selectedColor: selectedColor,
  children: /*#__PURE__*/_jsx(Knob, {
    size: size,
    active: active
  })
});